import React from 'react';
import Order from './order';
import ApiLiveOrders from './ApiLiveOrders';

const Home = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("token");
    const type = localStorage.getItem("type");

    if (type === "kitchen") {
        return <Order token={token} baseUrl={baseUrl} />;
    }

    return <ApiLiveOrders token={token} baseUrl={baseUrl} />;
};

export default Home;